import { useEffect, useState } from 'react'

const hasContentBelow = (element: HTMLElement): boolean =>
  element.scrollHeight - element.scrollTop - element.clientHeight > 1

/** True while a scroll container has content past its bottom edge. */
export const useHasContentBelow = (element: HTMLElement | null): boolean => {
  const [below, setBelow] = useState(false)

  useEffect(() => {
    if (!element) return undefined
    const update = () => setBelow(hasContentBelow(element))
    update()

    element.addEventListener('scroll', update, { passive: true })
    const resizes =
      typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update)
    const observeBoxes = () => {
      resizes?.disconnect()
      resizes?.observe(element)
      Array.from(element.children).forEach((child) => resizes?.observe(child))
    }
    observeBoxes()
    const mutations = new MutationObserver(() => {
      observeBoxes()
      update()
    })
    mutations.observe(element, { childList: true, subtree: true })

    return () => {
      element.removeEventListener('scroll', update)
      mutations.disconnect()
      resizes?.disconnect()
    }
  }, [element])

  return below
}
